import React from 'react';
import buttonPropTypes from './ButtonProptypes';
import PrimaryButton from './PrimaryButton';

const SecondaryButton = ({ children, customClass = '', ...rest }) => {
  const buttonStyles = `bg-white border-[2px] border-custom-light-blue !text-black ${customClass}`;

  return (
    <PrimaryButton customClass={buttonStyles} {...rest}>
      {children}
    </PrimaryButton>
  );
};

SecondaryButton.propTypes = buttonPropTypes;

export default SecondaryButton;
